<template>
    <div class="mt-5 pt-5 login-wrapper">
        <div class="row">
            <div class="col-4 m-auto">
                <form
                    class="shadow p-5"
                    @submit.prevent="login"
                >
                    <div class="pt-2">
                        <base-input
                            v-model="email"
                            :errors="errors.email"
                            autocomplete="username"
                        >
                            Email*
                        </base-input>
                    </div>

                    <div class="mt-3 pt-1">
                        <base-input
                            v-model="password"
                            :errors="errors.password"
                            autocomplete="current-password"
                            type="password"
                        >
                            Mot de passe*
                        </base-input>
                    </div>

                    <div class="form-group mt-4 pt-2">
                        <button
                            v-btn-loading="connecting"
                            type="submit"
                            class="btn btn-primary px-4 m-auto d-block"
                        >
                            Se connecter
                        </button>
                    </div>

                    <div class="clearfix" />
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import BaseInput from "../templates/BaseInput"

    export default {
        name: "UserLogin",
        components: {BaseInput},
        data: function() {
            return {
                email: '',
                password: '',
                connecting: false,
                errors: {}
            }
        },

        methods: {
            /**
             * Connecte l'utilisateur
             */
            login: function() {
                this.connecting = true

                axios.post('/auth/login', {
                    'email': this.email,
                    'password': this.password
                }).then(this.loginSuccess).catch(this.loginError)
            },

            /**
             * Callback de succès de l'authentification
             */
            loginSuccess: function () {
                this.$store.commit('saveLogin')
                this.$store.dispatch('init')
                this.connecting = false
                this.$notify('success', "Vous avez bien été connecté.")
                this.$router.push({name: 'dossiers'})
            },

            /**
             * Callback d'erreur de l'authentification
             */
            loginError: function () {
                this.$notify('danger', "Nom d'utilisateur ou mot de passe incorrect.")
                this.connecting = false
                this.errors = {email: [], password: []}
            }
        }
    }
</script>
